import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../common/page_component/index.js';
import Alert from '../common/Alert.js';
import roleService from '../../services/RoleService.js';
import { Settings  } from "lucide-react";
import Button from '../common/Button.js';
import { useTranslation } from 'react-i18next';

const AddRole = () => {
  const [formData, setFormData] = useState({
    role_name: '',
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await roleService.create(formData);
      Alert.success('Role created successfully!');
      setTimeout(() => navigate('/roles'), 1500);
    } catch (err) {
      Alert.error(err.response?.data?.error || 'Failed to create role');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-4 sm:mb-6">
          <h1 className="text-2xl sm:text-xl font-bold text-secondary flex items-center gap-2 sm:gap-3">
              <Settings className="w-5 h-5 text-buttonBg" />
              Add New Role
          </h1>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm p-4 sm:p-6 md:p-8 space-y-6 sm:space-y-8">
          {/* Role Information */}
          <div>
            <h3 className="text-base sm:text-md font-semibold text-gray-700 mb-3 sm:mb-4 pb-2 border-b-2 border-grey-400">
              Role Information
            </h3>
            <div>
              <label className="block text-sm font-medium text-gray-900 mb-2">Role Name <span class="text-danger font-bold">*</span></label>
              <input
                type="text"
                name="role_name"
                value={formData.role_name}
                onChange={handleChange}
                placeholder="Enter role name (e.g., Manager, Supervisor)"
                className="w-full sm:w-1/3 px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
              <p className="text-xs sm:text-sm text-gray-600 mt-2">Enter a descriptive name for the role</p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-2">
            <Button type="submit" loading={loading}>
              {loading ? 'Creating...' : 'Create Role'}
            </Button>
            <Button variant="secondary" onClick={() => navigate('/roles')}>
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default AddRole;
